var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHcBulkUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9545_2189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 4.7981H3.99931C3.11917 4.7981 2.39905 5.51821 2.39905 6.39836V14.3997C2.39905 15.2798 3.11917 15.9999 3.99931 15.9999H12.0006C12.8808 15.9999 13.6009 15.2798 13.6009 14.3997V6.39836C13.6009 5.51821 12.8808 4.7981 12.0006 4.7981ZM12.8007 3.5979H3.19918C3.19918 2.93379 3.73527 2.39771 4.39937 2.39771H11.6005C12.2647 2.39771 12.8007 2.93379 12.8007 3.5979ZM12.0006 1.19751H3.99931C3.99931 0.533402 4.5354 -0.00268555 5.1995 -0.00268555H10.8004C11.4645 -0.00268555 12.0006 0.533402 12.0006 1.19751Z",
    fill: "#0073E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9545_2189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcBulkUploadIcon);
export default __webpack_public_path__ + "static/media/hc-bulk-upload-icon.e575ff0faa1f5fb818d85dbcc368931c.svg";
export { ForwardRef as ReactComponent };